import { doDelete, doGet, doPost, doPut } from './axiosCrud';

//User
export const login = (body) => doPost('/bo_login', body);
export const checkUserToken = () => doGet('/bo_user/check_token');
export const getLaunchpadUsers = () => doGet('/users');
export const getBackofficeUsers = () => doGet('/bo_users');
export const updateLaunchpadUser = (userID, body) => doPut('/user/' + userID, body);
export const resendLaunchpadActivationEmail = (userID) =>
  doPost(`/user/${userID}/activation-email`);
export const createBackofficeUser = (body) => doPost('/bo_create_user',body);
export const updateBackofficeUser = (userID,body) => doPut('/bo_user/' + userID,body);
export const resendBackofficeActivationEmail = (userID) =>
  doPost(`/bo_user/${userID}/activation-email`);
export const activation = (body) => doPost('/bo_activate', body);
export const resendVerificationEmail = () => doPost('/user/bo_activation_email');
export const forgotPassword = (body) => doPost('/bo_password-recovery', body);
export const resetPassword = (body) => doPost('/bo_reset-password', body);
export const validatePasswordResetToken = (body) =>
  doPost('/bo_password-reset-token/validate', body);
//Projects
export const getProjects = (filter) => {
  const query = filter ? { filter } : undefined;
  return doGet('/projects', query);
};
export const createProject = (body) => doPost('/projects',body);
export const updateProject = (projectID,body) => doPut('/projects/' + projectID,body);
export const deleteProject = (projectID) => doDelete('/projects/'+ projectID);
export const putProjectImageLogo = (projectID, formData) =>
  doPut(`/projects/${projectID}/image`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
export const getProjectImage = (projectID) =>
  doGet(`/projects/${projectID}/image`, undefined, { responseType: 'blob' });
export const getProjectLogo = (projectID) =>
  doGet(`/projects/${projectID}/logo`, undefined, { responseType: 'blob' });

//Tokens
export const getTokens = () => doGet('/tokens');
export const createToken = (body) => doPost('/tokens',body);
export const updateToken = (tokenID,body) => doPut('/tokens/' + tokenID,body);
export const deleteToken = (tokenID) => doDelete('/tokens/' + tokenID);

//NFTs
export const getNfts = () => doGet('/nft');
export const createNft = (body, fromFunc = false) => doPost(`/nft?from_func=${fromFunc}`, body);
export const updateNft = (nftID, body) => doPut('/nfts/' + nftID, body);
export const deleteNft = (nftID) => doDelete('/nfts/' + nftID);

//Transactions
export const getTransactions = () => doGet('/transaction');
export const getBoTransaction = () => doGet('/bo_transaction');
export const boTransaction = (body) => doPost('/bo_transaction', body);
//Locks
export const getLocks = () => doGet('/locking/history');
export const getStakes = () => doGet('/staking/history');

export const getWalletHistory = (wallet) => doGet('/user/wallet_history/' + wallet);
export const newtorkChain = (chainId) => doPost('/chain/' + chainId);
export const getTier = (id) => doGet('/tier/' + id);
export const putTier = (id) => doPut('/tier/' + id);


export const GetAbiList = (body) => doGet('/contracts', body);
export const createContract = (formData) => 
  doPost('/contracts', formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const updateContract = (id, formData) =>
  doPut(`/contracts/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });


export const getBNB = () => doGet('/bnb');

//default
export const enable2fa = (totp_code) => doPost('/bo_enable_2fa/' + `${totp_code}`);
export const getGenerateQR = () => doGet('/bo_generate_qr');
export const verify2fa = (totp_code) => doPost('/bo_verify_2fa/'
 + `${totp_code}`);
 export const create2fa = () => doPost('/bo_create_2fa');
